import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { API } from "@/lib/api";
import { ConsultReport } from "./ConsultReport";
import "./HBMConsult.css";

export default function PublicConsultShare() {
  const { shareId } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    fetch(`${API}/consult/share/${shareId}`)
      .then(async (r) => { if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "unavailable"); return r.json(); })
      .then((d) => setState({ loading: false, data: d }))
      .catch((e) => setState({ loading: false, error: e.message || "This report is unavailable." }));
  }, [shareId]);

  if (state.loading) {
    return <div className="hbmc" style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className="kicker"><Loader2 size={14} className="animate-spin" style={{ display: "inline", marginRight: 8 }} />Loading shared report…</div>
    </div>;
  }
  if (state.error) {
    return <div className="hbmc" style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ textAlign: "center", maxWidth: 460 }}>
        <div className="kicker">HBM Consult</div>
        <h1 style={{ fontFamily: "Instrument Serif,serif", fontSize: 30, margin: "10px 0" }}>Report unavailable</h1>
        <p className="muted" style={{ fontSize: 14 }}>{state.error} The owner may have disabled this shared link.</p>
      </div>
    </div>;
  }

  const { data } = state;
  const a = data.analysis || {};
  return (
    <div className="hbmc" style={{ minHeight: "100vh", background: "var(--bg)" }}>
      <div style={{ maxWidth: 1180, margin: "0 auto", padding: "24px 22px 80px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <span className="kicker">HBM Consult · Decision Intelligence</span>
          <span className="hbmc-badge" data-testid="public-readonly-badge">Read-only shared report</span>
        </div>
        <header style={{ margin: "22px 0 16px" }}>
          <div className="kicker">{data.name || "Shared consulting project"}</div>
          <h1 style={{ fontFamily: "Instrument Serif,serif", fontSize: 40, lineHeight: 1.08, margin: "6px 0 0", letterSpacing: "-.02em" }}>{a.question || a.company}</h1>
          <small className="dim">{a.company}{a.document?.sha256 ? ` · checksum ${String(a.document.sha256).slice(0, 12)}…` : ""}</small>
        </header>
        <div className="hbmc-card" data-testid="ai-disclosure" style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 8, borderColor: "var(--accent)" }}>
          <ShieldCheck size={18} style={{ color: "var(--accent)", flexShrink: 0 }} />
          <p style={{ fontSize: 13, margin: 0 }}>{data.ai_disclosure || "This report was produced with AI-assisted analysis (EU AI Act, Article 50)."}</p>
        </div>
        <ConsultReport a={a} />
      </div>
    </div>
  );
}
